import { createAsyncThunk } from "@reduxjs/toolkit";

import api from "api";
import { proceedThunk } from "./utils";

export const checkoutSessionThunk = createAsyncThunk(
  "stripe/checkoutSession",
  proceedThunk(api.auth.checkoutSession)
);

export const customerPortalThunk = createAsyncThunk(
  "stripe/customerPortal",
  proceedThunk(api.auth.customerPortal)
);

export const subscriptionsListThunk = createAsyncThunk(
  "stripe/subscriptions/list",
  proceedThunk(api.auth.getSubscriptions)
);
